const PageForbidden = () => {
  return <div>403 PageForbidden</div>
}

export default PageForbidden
